import React, { memo } from 'react';
import colors from '../../styles/_colors.module.scss';
import styles from './successGradient.module.scss';

export default memo(function SuccessGradient() {
    return (
        <svg aria-hidden="true" focusable="false" className={styles.linearGradientSVG}>
            <defs>
                <linearGradient gradientTransform="skewX(50)" id="gradient-horizontal-success">
                    <stop offset="0%" stopColor={colors.fourthGreen} />
                    <stop offset="10.12%" stopColor={colors.thirdGreen} />
                    <stop offset="21.84%" stopColor={colors.secondGreen} />
                    <stop offset="50.56%" stopColor={colors.primaryGreen} />
                    <stop offset="190%" stopColor={colors.fifthGreen} />
                </linearGradient>
            </defs>
        </svg>
    );
});
